import React, {useState, useEffect} from 'react';
import RomoteControl from '../../../assets/img/dashboard/remoteControl';
import RomoteControlIcon from '../../../assets/img/dashboard/remoteControlIcon';
import MuteIcon from '../../../assets/img/dashboard/iconMute';
import VolumnIcon from '../../../assets/img/dashboard/iconVolumn';
import { useDebouncedCallback } from 'use-debounce';


const TVRemoteType = ({selectedItem,handlePostData, action}) => {
	const [channel, setChannel ] = useState([]);
	const [, setMute ] = useState(selectedItem.mute ? selectedItem.mute : false);
	const [channelNumbers, setChannelNumbers] = useState([]);
	// let typingTimer = null;

	useEffect(()=> {
		var numbers = [];
		for(var i = 1; i < 10; i++){
			numbers.push(i); // 1~9까지 
		}
		setChannelNumbers(numbers);
	
	}, [])

	const debounced = useDebouncedCallback(
		// function
		(value) => {
		
				handlePostData("setChannel", Number(value.join('')));
				setChannel([])
		
			
		},
		// delay in ms
		800
	  );

	const handleChanel = (number) => {
      let numbers = [...channel, number];
      if(numbers.length >= 3) {
        numbers.splice(0 , numbers.length - 3)
      }

      setChannel(numbers)
      debounced.callback(numbers) // 해당 번호로 Channel 설정하는 API 호출
      action();
	}

	const handleMute = (bool)=> {
		setMute(bool);
		handlePostData("mute", bool);
		action();
	}
	const handleControl = (key, value) => {
		handlePostData(key, value);
		action();
	}


	return (
	
		<section className="device-setting-body tv-remote-wrap">
			<div className="device-display tv-remote">
				<div className="display">
					<p 
						className="remote-top" 
						onClick={()=>handleControl('volume', 'up')}
					>
						<RomoteControl direction="top"/>
						<RomoteControlIcon direction="top"/>
					</p>
					<p 
						className="remote-bottom"  
						onClick={()=>handleControl('volume', 'down')}
					>
						<RomoteControl direction="bottom"/>
						<RomoteControlIcon direction="bottom"/>
					</p>
					<p 
						className="remote-left"  
						onClick={()=>handleControl('channel', 'down')}
					>
						<RomoteControl direction="left"/>
						<RomoteControlIcon direction="left"/>
					</p>
					<p 
						className="remote-right"  
						onClick={()=>handleControl('channel', 'up')}
					>
						<RomoteControl direction="right"/>
						<RomoteControlIcon direction="right"/>
					</p>
				</div>
			</div>
			<div className="device-control-wrap">
				<div className="device-control device-control-flex">
					<ul className="channel-numbers">
						{channelNumbers.map(v => <li onClick={() => handleChanel(v)} key={v}>{v}</li>)}
						<li onClick={() => handleMute(true)} key={11}><MuteIcon /></li>
						<li onClick={()=> handleChanel(0)} key={12}>0</li>
						<li onClick={()=> handleMute(false)} key={13}><VolumnIcon /></li>
					</ul>
				</div>
			</div>
		</section>
	
	
	);
}

export default TVRemoteType;